import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import useStore from '../../../Store/Store';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Progress = ({ total, value }) => {
  return (
    <CircularProgressbar
      value={value}
      maxValue={total}
      circleRatio={0.8}
      styles={{
        root: {},
        path: {
          stroke: `#8cd03b`,
          strokeLinecap: 'butt',
          transition: 'stroke-dashoffset 0.5s ease 0s',
          transform: 'rotate(0.6turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
        },
        trail: {
          stroke: 'grey',
          strokeLinecap: 'butt',
          transform: 'rotate(0.60turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
          strokeOpacity: '0.3',
        },
      }}
    />
  );
};

export default function ActivityCard() {
  const { t } = useTranslation();

  const history = useNavigate();
  const deviceActivities = useStore((state) => state.deviceActivities);
  const width = useStore((state) => state.screenWidth);
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '352px',
        padding: '24px 24px 24px 24px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden',
        marginLeft: width > 550 ? '20px' : '0px',
      }}
      className="main-container top-margin-card"
    >
      <Progress total={5000} value={deviceActivities?.steps || 0} />
      <span style={{ textAlign: 'center' }}>{t('totalDailySteps')}</span>
      <div className="frame-6b">
        <div className="slash">
          <span className="number-10">{deviceActivities?.steps || 0}</span>
        </div>
        <span className="minutes">{t('steps')}</span>
      </div>
    </div>
  );
}
